import React from "react";
import { observer } from "mobx-react";

// Translate
import translate from '../Translate.js';
import SpinButton from "../Common/SpinButton";
//import Toggle from "../Common/Toggle"
import MultiSelect from "../Common/MultiSelect"
import {checkValidityHybrid, getParam, getURLSegment} from "../../helpers/helpers";
import {setToken} from "../../config";

const HybridSettings = observer(
    class Settings extends React.Component {
        constructor() {
            super();

            // Set the initial state
            this.state = {
                installs: [],
                installSids: [],
                installSidManual: false,
                courses: [],
                courseSids: [],
                isShared: true,
                maxStudents: 1,
                roomName: null
            };
        };


        async componentDidMount() {
            const { SessionStore, HybridStore } = this.props.store;
            const roomSid = getURLSegment(this, 3);
            const token = getParam('token', window.location.href);
            if(roomSid && token){
                setToken(token);
                SessionStore.startTokenTimer(token);
                await HybridStore.listAvailableRooms();
                await HybridStore.editProctorRoomStartingOutside(roomSid);
            }
            if (!SessionStore.userData.role) {
                // We do not have a role, so we will get available installs for the proctor account
                const installData = await HybridStore.listInstalls(SessionStore.userData.proctorAccountSid);

                if (installData.length > 0) {
                    let installs = [];
                    installData.forEach(install => {
                        installs.push({
                            label: install.installName,
                            value: install.installSid
                        });
                    });
                    this.setState({
                        installs
                    });
                }
            } else if (SessionStore.userData.role === 'instructor') {
                const courseData = await HybridStore.listInstructorCourses(HybridStore.userData.installSid, HybridStore.userData.userSid);
                const courses = [];

                courseData.forEach(course => {
                    courses.push({
                        label: course.title,
                        value: course.sid
                    })
                });
                this.setState({
                    courses
                });
            }

            // If we are editing a room, we need to populate the default values
            if (HybridStore.isEditing) {
                const roomDefaults = HybridStore.roomDefaultValues;
                this.setState({
                    courseSids: roomDefaults.courseSids || [],
                    installSids: roomDefaults.installSids || [],
                    isShared: roomDefaults.isShared || false,
                    maxStudents: roomDefaults.maxStudents || 1,
                    roomName: roomDefaults.roomName || null
                });
            }
        };

        /**
         * Store input values.
         *
         * @function handleInput
         * @param {event} e
         */
        handleInput = e => {
            const { name, value } = e.target;

            this.setState({
                [name]: value
            });
        };

        /**
         * Store the selected school’s installSid.
         *
         * @function handleSelectInstall
         * @param {array} installSids
         */
        handleSelectInstall = installSids => {
            this.setState({
                installSids,
                installSidManual: false
            });
        };

        /**
         * Store the selected course's courseSid
         *
         * @function handleSelectCourse
         * @param {array} courseSids
         */
        handleSelectCourse = courseSids => {
            this.setState({
                courseSids
            });
        };

        /**
         * Submit the settings form.
         *
         * @function handleSubmit
         */
        handleSubmit = async () => {
            const { installSids, courseSids, isShared, maxStudents, roomName } = this.state;
            const { HybridStore } = this.props.store;
            const { setCreateNew } = this.props;
            const roomSid = getURLSegment(this, 3);

            const data = {
                installSids,
                courseSids,
                isShared,
                maxStudents,
                roomName
            };

            if (HybridStore.isEditing) {
                // We are editing a proctor room, so we have to call the update endpoint
                await HybridStore.updateProctorRoom(HybridStore.roomDefaultValues.sid, data);
            } else {
                // we are creating a new proctor room, so we have to call the create endpoint
                await HybridStore.createProctorRoom(data);
            }

            if (!roomSid) {
                HybridStore.stopEditing();
                setCreateNew(false);
            }
        };

        handleCancel = () => {
            const { HybridStore } = this.props.store;
            const { setCreateNew } = this.props;

            HybridStore.stopEditing();
            setCreateNew(false);
        }

        render() {
            const { translation } = this.props;
            const { HybridStore } = this.props.store;
            const { roomName, maxStudents, installs, installSids, courses, courseSids /*isShared*/ } = this.state;
            const roomSid = getURLSegment(this, 3);

            return (
                <main tabIndex="0" id="main-content" className="page">
                    <div className="wrap">
                        <header className="page__header">
                            <h1 className="page__title">{translation.heading}</h1>
                        </header>
                    </div>
                    <form
                        className="hybrid-form hybrid-form--separated hybrid-panel hybrid-panel--md hybrid-panel--solo"
                        noValidate
                        onSubmit={(e) => checkValidityHybrid(e, this.handleSubmit)}
                    >
                        <fieldset>
                            <legend>
                                { HybridStore.isEditing &&
                                <h1 className="hybrid-panel__title">
                                    {translation.edit_hybrid_room}
                                </h1>
                                }
                                { !HybridStore.isEditing &&
                                    <h1 className="hybrid-panel__title">
                                        {translation.create_new_hybrid_room}
                                    </h1>
                                }
                            </legend>

                            <ul className="hybrid-form__fields">
                                <li>
                                    <label
                                        className="hybrid-form__lbl lbl-required"
                                        htmlFor='room-name'
                                    >
                                        {translation.room_name.label}
                                    </label>

                                    <input
                                        aria-required="true"
                                        data-errormsg={translation.room_name.error_msg}
                                        value={roomName || ''}
                                        id="room-name"
                                        name="roomName"
                                        onChange={this.handleInput}
                                        placeholder={translation.room_name.placeholder}
                                        required
                                        type="text"
                                    />
                                </li>
                                <li>
                                    <SpinButton
                                        defaultValue={maxStudents}
                                        errorMsg={translation.max_students.error_msg}
                                        helper={translation.max_students.helper}
                                        id="max-students"
                                        label={translation.max_students.label}
                                        layout="horizontal"
                                        max={10}
                                        min={1}
                                        onChange={maxStudents => this.setState({ maxStudents })}
                                        required
                                    />
                                </li>
                                {/* NOTE (11/1/23): Chris Smith - Currently removed according to PR-1122 */}
                                {/* <li>
                                    <Toggle
                                        defaultChecked={isShared}
                                        helper={translation.is_shared.helper}
                                        id="is-shared"
                                        label={translation.is_shared.label}
                                        layout="horizontal"
                                        onChange={isShared => this.setState({ isShared })}
                                    />
                                </li> */}
                                {/* MultiSelect for proctors choosing which install(s) to proctor */}
                                {installs && installs.length > 0 &&
                                <li>
                                    <MultiSelect
                                        className="multi-select--horizontal"
                                        errorMsg={translation.install.error_msg}
                                        helper={translation.install.helper}
                                        id="install"
                                        label={translation.install.label}
                                        onChange={this.handleSelectInstall}
                                        options={installs}
                                        required
                                        value={installSids}
                                    />
                                </li>
                                }
                                {/* Show MultiSelect component for instructor as proctor courses */}
                                {courses && courses.length > 0 &&
                                <li>
                                    <MultiSelect
                                        className="multi-select--horizontal"
                                        errorMsg={translation.instructor_courses.error_msg}
                                        helper={translation.instructor_courses.helper}
                                        id="courses"
                                        label={translation.instructor_courses.label}
                                        onChange={this.handleSelectCourse}
                                        options={courses}
                                        required
                                        value={courseSids}
                                    />
                                </li>
                                }
                            </ul>
                        </fieldset>

                        <div className="hybrid-panel__action">
                            {!roomSid &&
                                <button
                                    className="btn btn--outline"
                                    onClick={this.handleCancel}
                                    type="reset"
                                >
                                    {translation.cancel}
                                </button>
                            }
                            <button className="btn" type="submit">
                                {translation.save}
                            </button>
                        </div>
                    </form>
                </main>
            );
        }
    }
);

export default translate("HybridSettings")(HybridSettings);



// WEBPACK FOOTER //
// ./src/app/components/Hybrid/HybridSettings.js